import { ActionTypeReducer, GenStateType, NestedKeys } from "helpers/types";
import { UsuarioModel } from "models/user_model";
import { EmpresaModelGet } from "models/empresa";

type StateType = {
    loggedUser: UsuarioModel;
    companyList: EmpresaModelGet[];
    company: EmpresaModelGet;
    loading: boolean;
    show: boolean;
    errorTitle: string;
    errorMsg: string;
    error: boolean;
    showDelete: boolean;
    showDeleteModal: boolean;
    companyFormFieldsError: Partial<Record<NestedKeys<StateType["company"]>, string>>;
}

type ActionType = GenStateType<StateType>;

const initialState: StateType = {
    loggedUser: null,
    companyList: [],
    company: {
        id: '',
        razaoSocial: '',
        nomeFantasia: '',
        inscricaoMunicipal: '',
        inscricaoEstadual: '',
        cnpj: '',
        dataCadastro: '',
        dataAtualizado: '',
        ativo: false,
        matriz: false,
        cnae: '',
        atividadePrincipal: '',
        regimeTributario: '',
        tamanhoEmpresa: '',
        comercio: false,
        ecommerce: false,
        industria: false,
        servicos: false,
        faturamentoUltimoAno: '',
        quantidadeFuncionarios: '',
        ContatoEmpresa: [
            {
                idEmpresa: '',
                cargo: '',
                email: '',
                nome: '',
                celular: '',
                principal: true,
                telefone: '',
            }
        ],
        EnderecoEmpresa: [
            {
                idEmpresa: '',
                cep: '',
                local: '',
                numero: '',
                bairro: '',
                complemento: '',
                cidade: '',
                estado: '',
                principal: true,
            }
        ]
    },
    loading: false,
    show: false,
    errorTitle: '',
    errorMsg: '',
    error: false,
    showDelete: false,
    showDeleteModal: false,
    companyFormFieldsError: {
        razaoSocial: '',
        nomeFantasia: '',
        inscricaoMunicipal: '',
        inscricaoEstadual: '',
        cnpj: '',
        dataCadastro: '',
        dataAtualizado: '',
        cnae: '',
        atividadePrincipal: '',
        regimeTributario: '',
        tamanhoEmpresa: '',
        faturamentoUltimoAno: '',
        quantidadeFuncionarios: '',
        'ContatoEmpresa.cargo': '',
        'ContatoEmpresa.email': '',
        'ContatoEmpresa.nome': '',
        'ContatoEmpresa.celular': '',
        'ContatoEmpresa.telefone': '',
        'EnderecoEmpresa.cep': '',
        'EnderecoEmpresa.local': '',
        'EnderecoEmpresa.numero': '',
        'EnderecoEmpresa.bairro': '',
        'EnderecoEmpresa.complemento': '',
        'EnderecoEmpresa.cidade': '',
        'EnderecoEmpresa.estado': '',
    }
};

const reducer = (state: StateType, action: ActionTypeReducer<ActionType>) => {
    switch (action.type) {
        case "setCompany":
            return { ...state, company: action.payload };
        case "setCompanyList":
            return { ...state, companyList: action.payload };
        case "setLoading":
            return { ...state, loading: action.payload };
        case "setShow":
            return { ...state, show: action.payload };
        case "setErrorTitle":
            return { ...state, errorTitle: action.payload };
        case "setErrorMsg":
            return { ...state, errorMsg: action.payload };
        case "setError":
            return { ...state, error: action.payload };
        case "setShowDelete":
            return { ...state, showDelete: action.payload };
        case "setShowDeleteModal":
            return { ...state, showDeleteModal: action.payload };
        case "setLoggedUser":
            return { ...state, loggedUser: action.payload };
        case "setCompanyFormFieldsError":
            return { ...state, companyFormFieldsError: action.payload };
        default:
            return state;
    }
}

export { initialState, reducer };
